import React, { useState } from "react";
import {Button, TextField, MenuItem, FormControl, InputLabel, Select, Typography, Box, Container } from "@mui/material";
import { doc, setDoc, getDocs, collection, where, query } from "firebase/firestore";
import { firestore } from "../firebase.config";
import PageNavBar from "../components/PageNavBar"; 
import { useUserContext } from "../context/UserContext";
import TenantBanner from "../components/TenantBanner";

const AddUser = () => {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [role, setRole] = useState("user"); // Default role is user
  const [error, setError] = useState("");

  const { userRole, tenantId, tenantName, selectedTenantId, selectedTenantName, setUserId, setUserRole, setTenantId, setTenantName } = useUserContext();

  const roles = [
    { value: "admin", label: "Admin" },
    { value: "user", label: "User" },
  ];
  // Get logged-in user's email from sessionStorage
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const loggedInEmail = loggedInUser?.email || "";

  const handleAddUser = async () => {
    if (!userName || !userEmail || !role) {
      setError("All fields are required.");
      return;
    }

    // let assignedTenantID = "";
    // let assignedTenantName = "";

    // if (userRole === "SuperAdmin") {
    //   // Always use sessionStorage for SuperAdmin
    //   assignedTenantID = sessionStorage.getItem("selectedTenantID") || "";
    //   assignedTenantName = sessionStorage.getItem("selectedTenantName") || "";
    // } else {
    //   // For Admin, use their own tenant info from context
    //   assignedTenantID = tenantID || "";
    //   assignedTenantName = tenantName || "";
    // }
    let assignedTenantId = "";
    let assignedTenantName = "";

    if (userRole === "SuperAdmin") {
      assignedTenantId = sessionStorage.getItem("selectedTenantId");
      assignedTenantName = sessionStorage.getItem("selectedTenantName");

    if (!assignedTenantId || !assignedTenantName) {
      alert("SuperAdmin must select a tenant first.");
    return;
    }
    } else {
      // // Use from context first, fallback to sessionStorage
      // assignedTenantID = tenantID || sessionStorage.getItem("selectedTenantID");
      // assignedTenantName = tenantName || sessionStorage.getItem("selectedTenantName");
      // For admin
      if (tenantId && tenantName) {
        assignedTenantId = tenantId;
        assignedTenantName = tenantName;
      } else {
        // Fetch from Firestore
        const userQuery = await getDocs(
          query(
            collection(firestore, "Users"),
            where("userEmail", "==", loggedInEmail),
            where("Is_Active", "==", true)
          )
        );

        if (!userQuery.empty) {
          const adminData = userQuery.docs[0].data();
          assignedTenantId = adminData.tenantId || "";
          assignedTenantName = adminData.tenantName || "";

          // Store in session or context if needed
          sessionStorage.setItem("selectedTenantId", assignedTenantId);
          sessionStorage.setItem("selectedTenantName", assignedTenantName);

         
        }
      }
      if (!assignedTenantId || !assignedTenantName) {
        alert("Tenant info missing for admin user.");
      return;
      }   
    }
    try {
      // Add user to Firestore
      const userRef = doc(firestore, "Users", userEmail);
      await setDoc(userRef, {
        userName,
        userEmail,
        role,
        Is_Active: true,
        tenantId: assignedTenantId,
        tenantName: assignedTenantName
      });

      setError(""); // Clear any error after successful addition
      alert("User added successfully!");
      setUserName(""); // Reset form
      setUserEmail("");
      setRole("user");
    } catch (error) {
      console.error("Error adding user:", error);
      setError("Failed to add user. Please try again.");
    }
  };

  return (
    <Container maxWidth="md">
      {/* Custom App Bar */}
      <PageNavBar title="Add User" backTo="/dashboard" />
      {/* Tenant Banner */}
      <TenantBanner />

      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Add New User
        </Typography>

        <Box
            sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: 2, textAlign: 'center', mt: 4 }}
        >
          <TextField
            fullWidth
            label="User Name"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="User Email"
            type="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            margin="normal"
            required
          />

          <TextField
            select
            fullWidth
            label="Role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            margin="normal"
            required
          >
            {roles.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            onClick={handleAddUser}
          >
            Add User
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AddUser;
